
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import Text from '../../../common/client/components/Text';

import IfComp from '../IfComp';
import LinkToTeleso from './LinkToTeleso';
import ListInfoLoading from './ListInfoLoading';
import ListInfoNoData from './ListInfoNoData';

const classNames = mergeStyleSets({
    row: {
        paddingLeft: 0,
    },
    rowCompact: {
        paddingLeft: 0,
    },
    telClick: {
        '&:hover': {
            backgroundColor: '#dddddd',
            cursor: 'pointer'
        }
    },
    telTitle: {
        paddingLeft: 0,
        paddingBottom: 4
    },
    telKatuze: {
        width: 200
    },
    telCislo: {
        width: 100
    },
    telContainer: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    },
    telContainerCompact: {
        paddingTop: 4,
        paddingBottom: 4,
        paddingLeft: 0
    }
});

const IsknTelTitle = () => {
    return (
        <Stack horizontal verticalAlign="end" className={classNames.telTitle}>
            <Text bold className={classNames.telKatuze}>Katastrální území</Text>
            <Text bold className={classNames.telCislo}>Číslo LV</Text>
        </Stack>
    );
}

const IsknTelItem = ({compact, isknDate, telItem, onClick}) => {

    const handleClick = () => {
        if (onClick) {
            onClick(telItem.tel_id);
        }
    }

    let classNamesArr = [compact ? classNames.rowCompact : classNames.row];
    if (onClick) {
        classNamesArr.push(classNames.telClick)
    }

    return (
        <Stack horizontal verticalAlign="end" className={classNamesArr.join(' ')} onClick={handleClick}>
            <IfComp cond={compact}>
                <Text className={classNames.telKatuze}>{telItem.katuze_name}</Text>
                <Stack.Item className={classNames.telCislo}>
                    <LinkToTeleso isknDate={isknDate} tel={telItem} />
                </Stack.Item>
            </IfComp>
            <IfComp cond={!compact}>
                <Text className={classNames.telKatuze}>{telItem.katuze_name}</Text>
                <Text className={classNames.telCislo}>{telItem.cislo_tel}</Text>
            </IfComp>
        </Stack>
    );
}

const IsknTelList = ({compact, isknDate, data, loading, onClick}) => {

    return (
        <Stack className={compact ? classNames.telContainerCompact : classNames.telContainer}>
            <IfComp cond={!compact && (data.tel.length > 0)}>
                <IsknTelTitle />
            </IfComp>
            {data.tel.map(item => {
                return (
                    <IsknTelItem
                        key={item.tel_id}
                        compact={compact}
                        isknDate={isknDate}
                        telItem={item}
                        onClick={onClick}
                    />
                );
            })}
            <IfComp cond={loading}>
                <ListInfoLoading />
            </IfComp>
            <IfComp cond={(data.tel.length === 0) && !loading}>
                <ListInfoNoData />
            </IfComp>
        </Stack>
    );
}

export default IsknTelList;
